import axios from 'axios';

import { Environment } from '../constants/environments';

export interface DDICountry {
  alpha2Code : string;
  alpha3Code : string;
  callingCode : string;
  id : string;
  name : string;
  priority : string;
}

export async function getDDIList(): Promise<DDICountry[]> {
  const response = await axios.get<{ responseData : DDICountry[] }>(
    `${Environment.API_URL}/country?apikey=${Environment.API_KEY}`
  );
  return response.data?.responseData ?? [];
}
